componentRegistryInstance.register('eval', 'read', 'hrd.components.form.EvalComponent');

hrd.components.form.EvalComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.EvalComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	setReadOnlyField: function(field, value, object, options) {
		let name = this.getFieldName();
		let fnName = $.functionCase(name + '-field-evaluate');
		if (this.settings.reference && typeof this.settings.reference[fnName] === 'function') {
			value = this.settings.reference[fnName].call(this.settings.reference, object, this.getFormInstance());
		} else {
			if (this.settings.reference) {
				console.log(`For defining the field-evaluator function, add method "${fnName}" to "${this.settings.reference._FULL_}"`);
			}
			// old scenario, kept for backward compatibility. deprecated
			if (field.data('name') != undefined) {
				var data = {};
				data[name] = value;
				value = field.triggerHandler('eval-field-value', data);
			} else {
				value = field.triggerHandler('eval-field-value', object);
			}
		}
		field.html(value);
	}
});